exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".margin-bot-10 {\n  margin-bottom: 10px;\n}\n\n.height-400 {\n  height: 400px;\n}\n\n.scrollable {\n  overflow: auto;\n}\n\n.btn.btn-block {\n  /* This fixes word wrapping on button blocks */\n  white-space: normal;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/modules/dialogs/dialogs-details/construct-list/construct-list.component.css
// module id = ../../../../../src/app/modules/dialogs/dialogs-details/construct-list/construct-list.component.css
// module chunks = main